<div class="conn-card">
    <app-report-top-filter-bar
        [paraReportName]="'merchant-payout-report'"
        (filterCallbackFunc)="callbackFuncFromFilter($event)"
        (filterCallbackFuncUpdateFilter)="filterButtonPressed()"
        (exportExcelFn)="exportExcel()"
        (exportPdfFn)="exportPdf()"
    ></app-report-top-filter-bar>

    <div class="grid mt-2 payout-widgets">
        <div class="col">
            <div class="conn-card" style="background:#f5f8fa">
                <div class="grid">
                    <div class="col-12 text-align-center">
                        <div>
                            <label class="widget-title">Total Sales</label>
                        </div>
                        <div>
                            <label class="widiget-figure-main">{{ summary.totalSales | currency | currencySpacing }}</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col">
            <div class="conn-card" style="background:#f5f8fa">
                <div class="grid">
                    <div class="col-12 text-align-center">
                        <div>
                            <label class="widget-title">Total Orders</label>
                        </div>
                        <div>
                            <label class="widiget-figure-main">{{ summary.totalOrders }}</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col">
            <div class="conn-card" style="background:#f5f8fa">
                <div class="grid">
                    <div class="col-12 text-align-center">
                        <div>
                            <label class="widget-title">Total Processing Fees</label>
                        </div>
                        <div>
                            <label class="widiget-figure-main">{{ summary.totalPaymentGatewayFees | currency | currencySpacing }}</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="col">
            <div class="conn-card" style="background:#f5f8fa">
                <div class="grid">
                    <div class="col-12 text-align-center">
                        <div>
                            <label class="widget-title">Total Platform Fees Collected</label>
                        </div>
                        <div>
                            <label class="widiget-figure-main">{{ summary.totalPlatformFeesCollected | currency | currencySpacing }}</label>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
        <div class="col">
            <div class="conn-card" style="background:#f5f8fa">
                <div class="grid">
                    <div class="col-12 text-align-center">
                        <div>
                            <label class="widget-title">Total Net Earnings / Payout</label>
                        </div>
                        <div>
                            <label class="widiget-figure-main">{{ summary.totalNetPayout | currency | currencySpacing }}</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <br />

    <p-table
        #dt
        [tableStyle]="{ width: 'max-content' }"
        [value]="isLoading ? skeletonRows : displayList"
        *ngIf="isLoading || displayList?.length > 0"
        [autoLayout]="true"
        responsiveLayout="scroll"
        [paginator]="false"
        [customSort]="true"
        (onLazyLoad)="customSort($event)"
        [lazy]="true"
        [rows]="rows"
        showLoader="true"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} orders"
        [rowsPerPageOptions]="[10, 25, 50, 100, 500, 1000]"
        selectionMode="single"
    >
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="orderNumber" style="text-align: center">
                    Order # <p-sortIcon field="orderNumber"></p-sortIcon>
                </th>
                <th pSortableColumn="customerName" style="text-align: center">
                    Customer Name <p-sortIcon field="customerName"></p-sortIcon>
                </th>
                <th pSortableColumn="totalAmountPaid" style="text-align: center">
                    Total Amount Paid <p-sortIcon field="totalAmountPaid"></p-sortIcon>
                </th>
                <th style="text-align: center">Processing Fee</th>
                <!-- <th style="text-align: center">Platform Fee</th> -->
                <th pSortableColumn="netPayout" style="text-align: center">
                    Net Payout <p-sortIcon field="netPayout"></p-sortIcon>
                </th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item>
            <tr *ngIf="isLoading; else dataRow" class="text-center">
                <td><p-skeleton width="5rem" height="1rem"></p-skeleton></td>
                <td><p-skeleton width="8rem" height="1rem"></p-skeleton></td>
                <td><p-skeleton width="6rem" height="1rem"></p-skeleton></td>
                <td><p-skeleton width="5rem" height="1rem"></p-skeleton></td>
                <td><p-skeleton width="5rem" height="1rem"></p-skeleton></td>
                <td><p-skeleton width="6rem" height="1rem"></p-skeleton></td>
            </tr>
            <ng-template #dataRow>
                <tr [pSelectableRow]="item" class="text-center">
                    <td style="text-align: center">{{ item.orderNumber }}</td>
                    <td style="text-align: center">{{ item.customerName }}</td>
                    <td style="text-align: center">{{ item.totalAmountPaid | currency | currencySpacing }}</td>
                    <td style="text-align: center">{{ item.paymentGatewayFee | currency | currencySpacing }}</td>
                    <!-- <td style="text-align: center">{{ item.platformFee | currency | currencySpacing }}</td> -->
                    <td style="text-align: center">{{ item.netPayout | currency | currencySpacing }}</td>
                </tr>
            </ng-template>
        </ng-template>

        <ng-template pTemplate="footer">
            <tr *ngIf="!isLoading && displayList?.length > 0">
                <td style="text-align: center"></td>
                <td style="text-align: center"><strong>Total</strong></td>
                <td style="text-align: center">{{ calculateSummaryTotal("totalAmountPaid") }}</td>
                <td style="text-align: center">{{ calculateSummaryTotal("paymentGatewayFee") }}</td>
                <!-- <td style="text-align: center">{{ calculateSummaryTotal("platformFee") }}</td> -->
                <td style="text-align: center">{{ calculateSummaryTotal("netPayout") }}</td>
            </tr>
        </ng-template>
    </p-table>

    <div class="flex" *ngIf="!isLoading && displayList?.length == 0">
        <div class="text-align-center" style="width: 100%">
            <span class="control-description text-muted text-align-center">No data found!</span>
        </div>
    </div>

    <div class="flex py-2" *ngIf="!isLoading && displayList?.length > 0">
        <p class="bold">
            <span class="bold text-surface-300">Note:</span>
            <span class="text-gray-600">
                Net Payout = Order Total − Payment Gateway Fee − Platform Fee.
            </span>
        </p>
    </div>

    <p-paginator
        *ngIf="!isLoading && dataList?.length > 0"
        [first]="first"
        (onPageChange)="onPageChange($event)"
        [rows]="rows"
        [totalRecords]="displayTotalRecords"
        [rowsPerPageOptions]="[10, 25, 50, 100, 500, 1000]"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Page: {currentPage} of {totalPages}, Total Records: {totalRecords}"
        #p
    >
    </p-paginator>
</div>
